
import { supabase } from '@/integrations/supabase/client';
import { Component, SortColumn, SortDirection } from '@/utils/types/componentTypes';

export async function fetchComponents(
  organizationId: string, 
  sortColumn: SortColumn = "name",
  sortDirection: SortDirection = "asc", 
  filter: string = "",
  typeFilter: string | null = null
): Promise<Component[]> {
  let query = supabase
    .from('components')
    .select(`
      *,
      component_types (
        id,
        name,
        icon,
        group_name
      )
    `)
    .eq('id_organization', organizationId);

  if (typeFilter) {
    query = query.eq('id_component_type', typeFilter);
  }

  if (filter) {
    query = query.ilike('name', `%${filter}%`);
  }

  const { data, error } = await query.order(sortColumn, { ascending: sortDirection === 'asc' });

  if (error) {
    console.error('Error fetching components:', error);
    throw error;
  }

  return data || [];
}

export async function fetchSubscriptionComponents(
  subscriptionId: string,
  filter: string = "",
  organizationFilter: string | null = null
): Promise<Component[]> {
  let query = supabase
    .from('components')
    .select(`
      *,
      component_types (
        id,
        name,
        icon,
        group_name
      ),
      organizations!inner (
        id,
        name,
        subscription_id
      )
    `)
    .eq('organizations.subscription_id', subscriptionId);

  if (organizationFilter && organizationFilter !== 'todas') {
    query = query.eq('id_organization', organizationFilter);
  }

  if (filter) {
    query = query.ilike('name', `%${filter}%`);
  }

  const { data, error } = await query
    .order('component_types(name)', { ascending: true })
    .order('name', { ascending: true });

  if (error) {
    console.error('Error fetching subscription components:', error);
    throw error;
  }

  return data || [];
}
